import { NetworkStatus } from '@apollo/client';

import { useCompanyTagsRepositoryInjector } from 'application/providers/DIContainerProvider';
import { useCompanyTagsPaginationPresenter } from 'application/presenters';
import { useAccountCompanyId } from 'application/hooks';

import { TagFiltersViewModel } from './types';

const useTagFiltersPresenter = (): TagFiltersViewModel => {
  const companyId = useAccountCompanyId();

  const { getCompanyTags, getMoreCompanyTags, readCompanyTags, companyTagsNetworkStatus, companyTagsCalled } =
    useCompanyTagsRepositoryInjector();

  const {
    companyTags,
    paginationInfo,
    allCompanyTagsCount,
    filtersRef,
    requestCompanyTags,
    loadMoreCompanyTags,
    resetFilters,
    onFilterExecute,
  } = useCompanyTagsPaginationPresenter({ getCompanyTags, getMoreCompanyTags, readCompanyTags });

  const companyTagsLoading =
    companyTagsNetworkStatus === NetworkStatus.loading || companyTagsNetworkStatus === NetworkStatus.setVariables;

  const isReady = companyTagsCalled && (!companyTagsLoading || companyTags.length !== 0);

  const isFilterQueryEmpty = !filtersRef.current.query;

  const isEmpty = isReady && companyTags.length === 0 && isFilterQueryEmpty;

  const isEmptyFiltered = isReady && companyTags.length === 0 && !isFilterQueryEmpty;

  return {
    companyId,
    isReady,
    isEmpty,
    isEmptyFiltered,
    companyTags,
    paginationInfo,
    companyTagsLoading,
    allCompanyTagsCount,
    requestCompanyTags,
    loadMoreCompanyTags,
    resetFilters,
    onFilterExecute,
  };
};

export default useTagFiltersPresenter;
